export const SENTRY_DSN =
  'https://574bf3d5ed9d1cade5afe9da72f53aa1@sentry.hamravesh.com/7616'

const MAIN_PAGE_TRACE_SAMPLE_RATE = 0.25
const DEFAULT_TRACE_SAMPLE_RATE = 0.01

const MAIN_PAGE_PATTERNS = [
  /^\/$/,
  /^\/search(\/|$)/,
  /^\/houses\/show(\/|$)/,
  /^\/login(\/|$)/,
  /^\/payments(\/|$)/,
  /^\/reservations(\/|$)/,
  /^\/trips(\/|$)/,
  /^\/all-boomgardi(\/|$)/,
  /^\/all-cottage(\/|$)/,
]

function normalizeTransactionName(value) {
  if (!value || typeof value !== 'string') return ''
  return value
    .replace(/^(GET|POST|PUT|PATCH|DELETE|HEAD|OPTIONS)\s+/i, '')
    .split('?')[0]
}

export function tracesSampler(samplingContext) {
  const name = normalizeTransactionName(
    samplingContext?.name || samplingContext?.transactionContext?.name,
  )
  const pathname = normalizeTransactionName(samplingContext?.location?.pathname)
  const isMainPage = [name, pathname].some(candidate =>
    MAIN_PAGE_PATTERNS.some(pattern => pattern.test(candidate)),
  )

  return isMainPage ? MAIN_PAGE_TRACE_SAMPLE_RATE : DEFAULT_TRACE_SAMPLE_RATE
}

export function getSentryBaseOptions() {
  const environment =
    process.env.APP_ENVIRONMENT ||
    (process.env.IS_PRODUCTION === 'true'
      ? 'production'
      : process.env.NODE_ENV || 'development')

  return {
    dsn: SENTRY_DSN,
    environment,
    tracesSampler,
    dist: process.env.IS_PRODUCTION === 'true' ? 'production' : undefined,
  }
}
